
export default function BusinessHours() {
  return (
    <section className="py-20 px-6 bg-beige-100/50">
      <div className="max-w-4xl mx-auto">
        <div className="flex items-center gap-4 mb-8">
          <div className="w-12 h-12 flex items-center justify-center">
            <i className="far fa-clock text-3xl text-amber-600"></i>
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900">
            Business Hours
          </h2>
        </div>

        <div className="bg-white rounded-lg shadow-lg p-8 border border-beige-200">
          <ul className="space-y-4">
            <li className="flex items-center justify-between pb-4 border-b border-beige-200">
              <span className="text-base font-medium text-slate-900">Monday - Saturday</span>
              <span className="text-base text-sky-600 font-medium">Open</span>
            </li>
            <li className="flex items-center justify-between">
              <span className="text-base font-medium text-slate-900">Sunday</span>
              <span className="text-base text-slate-700">Appointments only</span>
            </li>
          </ul>
        </div>
      </div>
    </section>
  );
}
